import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { I18N } from 'commons';
import { connect } from 'react-redux';
import * as helpAndAnswerSelectors from 'state/selectors/helpAndAnswerSelectors';
import * as helpAndAnswerActions from 'state/actions/helpAndAnswerActions';
import * as signUpConstants from 'constants/signUp';
import * as loginConstants from 'constants/login';
import * as homeConstants from 'constants/home';

const HelpAndAnswerTip = ({ type, content, path, getHelpAndAnswer, navContent, verifyLocationContent }) => {
  const [helpTipStatus, setHelpTipStatus] = useState(false);
  const { param, hasHelpAndAnswerTip = false } = useMemo(() => {
    if (!path) {
      return { hasHelpAndAnswerTip: true };
    }

    const paramObj = signUpConstants.paramMap.get(path) || loginConstants.paramMap.get(path) || homeConstants.paramMap.get(path);

    if (typeof (paramObj) !== 'undefined') {
      const { paramType } = paramObj;
      getHelpAndAnswer({ type: paramType });
      setHelpTipStatus(false);
    }

    return {
      param: paramObj,
      hasHelpAndAnswerTip: !!paramObj,
    };
  }, [path]);

  useEffect(() => {
    if (!path && type) {
      getHelpAndAnswer({ type });
      setHelpTipStatus(false);
    }
  }, []);
  const contentHtml = (!path && type) ? verifyLocationContent : navContent;
  const contentHtmlDisplay = contentHtml.replace(/(<img)/g, '$1 class="img-fluid"');
  const defaultContentDisplay = content || (param && param.defaultContent) || '';

  return (
    <>
      {hasHelpAndAnswerTip && (
        <div className="ssp-help-panel">
          <button
            className="ssp-help"
            onClick={() => setHelpTipStatus(!helpTipStatus)}
            aria-expanded={helpTipStatus}
            aria-controls="help-answer-container"
          >
            <em className={helpTipStatus ? 'icon_close' : 'icon_help'} />
            <I18N>member.portal.footer.help</I18N>
          </button>
        </div>
      )}
      {helpTipStatus && (
        <div
          id="help-answer-container"
          className={`help-answer-ct animate-show ${path ? '' : 'help-answer-scroll'}`}
          tabIndex="0"
        >
          <I18N>{contentHtmlDisplay || defaultContentDisplay}</I18N>
        </div>
      )}
    </>
  );
};

HelpAndAnswerTip.propTypes = {
  type: PropTypes.string,
  content: PropTypes.string,
  path: PropTypes.string,
  getHelpAndAnswer: PropTypes.func.isRequired,
  navContent: PropTypes.string,
  verifyLocationContent: PropTypes.string,
};

HelpAndAnswerTip.defaultProps = {
  type: '',
  content: '',
  path: '',
  navContent: '',
  verifyLocationContent: '',
};

const mapStateToProps = state => ({
  navContent: helpAndAnswerSelectors.selectNavContent(state),
  verifyLocationContent: helpAndAnswerSelectors.selectLocationContent(state),
});

const mapDispatchToProps = dispatch => ({
  getHelpAndAnswer: (data, callback) => {
    dispatch(helpAndAnswerActions.getHelpAndAnswer.action({ data, callback }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(HelpAndAnswerTip);
